import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id B2FDABD3-4E66-461C-8DC0-10D9A18441B8
 * name tooltip-check
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tooltip-check.svg
 * tags
 * - Tooltip 
 */
export const TooltipCheckIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V16C2 17.11 2.9 18 4 18H8L12 22L16 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M10.46 14L6.96 10.5L8.37 9.08L10.46 11.17L15.64 6L17.05 7.41L10.46 14Z" /></>, 'TooltipCheckIcon');
export default TooltipCheckIcon